import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {MessageService} from "primeng/api";
import {FormService} from "../../services/form.service";
import {Constants} from "../../types/constants";

@Component({
  selector: 'sign-response',
  templateUrl: './sign-response.component.html',
  styleUrls: ['./sign-response.component.css']
})
export class SignResponseComponent implements OnDestroy {

  severity : string = "error";
  title ?: string;
  message ?: string;
  description ?: string;
  objectUrl ?: string;
  filename ?: string;
  downloadButtonVisible : boolean = false;
  loading : boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService,
    private messageService: MessageService) {
  }

  ngOnInit() {
    this.objectUrl = undefined;
    this.downloadButtonVisible = false;
    this.loading = false;
    this.route.queryParams.subscribe(
      (params: Params) => {
        let status = params["status"];
        if (!status) {
          this.title = "Błąd";
          this.severity = 'error';
          this.message = "Błąd komunikacji z Podpisem Zaufanym";
          this.description = "Błędna odpowiedź z serwera Podpisu Zaufanego.Spróbuj ponownie później.";
          return;
        }
        switch (status) {
          case "FAILURE":
            this.title = "Błąd";
            this.severity = 'error';
            this.message = "Nie udało się podpisać dokumentu Podpisem Zaufanym";
            this.description = "Sprawdź poprawność danych logowania do Podpisu Zaufanego";
            return;
          case "CANCELED":
            this.title = "Błąd";
            this.severity = 'warn';
            this.message = "Anulowano podpisywanie dokumentu Podpisem Zaufanym";
            this.description = "Aby podpisać dokument wróć na listę wniosków i wybierz odpowiedni wniosek";
            return;
          case "SUCCESS":
            this.title = "Dziękujemy za skorzystanie z elektronicznego formularza wniosku o wpis do rejestru pośredników kredytowych (wnioski RPKiP). Trwa systemowa weryfikacja prawidłowości wniosku.";
            this.severity = 'success';
            this.message = "Urząd informuje, że fakt złożenia wniosku nie oznacza, że możesz prowadzić działalność pośrednictwa kredytowego. Komisja Nadzoru Finansowego dokonuje wpisu do rejestru w terminie 14 dni od dnia otrzymania wniosku, pod warunkiem, że dokumenty są kompletne i prawidłowe."
            this.description = "Dziękujemy, złożenie wniosku zostanie potwierdzone w kolejnej wiadomości email.";
            break;
          default:
            this.title = "Błąd";
            this.severity = 'error';
            this.message = "Błąd komunikacji z Podpisem Zaufanym";
            this.description = "Błędna odpowiedź z serwera Podpisu Zaufanego. Spróbuj ponownie później.";
            return;
        }

        let docId = params['documentId'];
        if (!docId) {
          this.severity = 'error';
          this.message = "Błąd komunikacji z Podpisem Zaufanym";
          this.description = "Błędna odpowiedź z serwera Podpisu Zaufanego. Spróbuj ponownie później.";
          return;
        }

        this.downloadButtonVisible = true;
        this.loading = true;
        this.formService.getDocument(docId, true).subscribe(
          response => {
            if (!response.body || !response.headers) {
              this.messageService.add({
                severity: 'error',
                detail: Constants.GenericError }
              );
              this.downloadButtonVisible = false;
              return;
            }

            let contentDisposition = response.headers.get('content-disposition');
            this.filename = "wniosek.zip";
            if (contentDisposition) {
              this.filename = contentDisposition
                .split(';')
                .map(h => h.trim())
                .filter(h => h.startsWith('filename='))
                .reduce(h => h.length === 1 ? h[0] : "wniosek.zip")
                .replace('filename=', '');
            }
            this.objectUrl = URL.createObjectURL(response.body);
            const a = document.createElement('a');
            a.href = this.objectUrl;
            a.download = this.filename ?? "wniosek.zip";
            a.click();
            this.loading = false;
          },
          error => {
            this.messageService.add({
              severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
              detail: error.error.message ?? Constants.GenericError}
            );
            this.downloadButtonVisible = false;
          }
        )
      }
    );
  }

  downloadProposal() {
    if (this.objectUrl) {
      const a = document.createElement('a');
      a.href = this.objectUrl;
      a.download = this.filename ?? "wniosek.zip";
      a.click();
    }
  }

  chooseForm(): void {
    this.router.navigate(['/choose-form']);
  }

  ngOnDestroy() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = undefined;
    }
  }
}
